module.exports = __webpack_public_path__ + "static/media/bytt-no-6.aedf9d0a.mp3";